import { useTheme } from '../theme'

/**
 * Fond de page du portail (S43) — l'UNIQUE endroit qui connait le decor de
 * theme : creme + halos en web2, sombre + gradient/grille en web3.
 * Remplace le motif duplique `min-h-screen ${isWeb3 ? 'portal-bg' : ...}`
 * + couches decoratives, copie dans App, HubShell et chaque module.
 *
 * `halos` : en web2, afficher les halos d'ambiance (hub et modules — pas les
 * pages design/connexion, fideles a leur rendu historique sans halos).
 */
export default function FondPage({ halos = false, className = '', children }) {
  const { isWeb3 } = useTheme()
  return (
    <div className={`min-h-screen ${isWeb3 ? 'portal-bg' : 'portal-bg-web2'} ${className}`.trim()}>
      {isWeb3
        ? <><div className="portal-bg-gradient" /><div className="portal-grid" /></>
        : halos && <div className="portal-halos"><div className="portal-halo portal-halo-1" /><div className="portal-halo portal-halo-2" /></div>}
      {children}
    </div>
  )
}
